import { TFunction } from 'i18next'
import { FetchBillingResponse } from '../../../../swagger'
import getLocaleCurrencyForAmount from '../../../../utils/getLocaleCurrencyForAmount'
import { ActionableTableColumn } from '../../../Table/ActionableTable'

export const mapBillingToLCDLicensingRows = (
  billingData: FetchBillingResponse
): Array<{
  communityName: string
  program: string
  tutorOwes: string
  communityDirectorOwes: string
  programKey: number
}> => {
  return (
    billingData.licensing?.billingInfo?.data?.map(
      ({
        program,
        programKey,
        community,
        tutorOwes,
        semesterOneStartDate,
        directorOwes,
      }) => ({
        communityName: community,
        program: `${program} (${new Date(
          semesterOneStartDate
        ).toLocaleDateString()})`,
        tutorOwes: getLocaleCurrencyForAmount(
          tutorOwes.amount,
          tutorOwes.currencyCode
        ),
        communityDirectorOwes: getLocaleCurrencyForAmount(
          directorOwes.amount,
          directorOwes.currencyCode
        ),
        programKey: programKey as number,
      })
    ) ?? []
  )
}

export const getLCDLicensingHeaders = (
  t: TFunction
): ActionableTableColumn[] => [
  {
    columnHeaderName: t(
      'LCDLicensingTable.Header.CommunityName',
      'Community Name'
    ),
    align: 'left',
    fieldName: 'communityName',
  },
  {
    columnHeaderName: t('LCDLicensingTable.Header.Program', 'Program'),
    align: 'left',
    fieldName: 'program',
  },
  {
    columnHeaderName: t(
      'LCDLicensingTable.Header.TutorBalance',
      'Tutors Balance to Director'
    ),
    align: 'left',
    headerAlign: 'left',
    fieldName: 'tutorOwes',
  },
  {
    columnHeaderName: t(
      'LCDLicensingTable.Header.DirectorBalance',
      'Director Balance to CC'
    ),
    align: 'left',
    headerAlign: 'left',
    fieldName: 'communityDirectorOwes',
  },
]
